import { Model } from '../Model.js';

var _dec, _class;

/**
 * Plain object ShipmentActions representation.
 *
 */

/**
 * Serialized object ShipmentActions representation.
 *
 */

/**
 * Plain object Packlink's API response representation.
 *
 */

let ShipmentActions = (_dec = Model(), _dec(_class = class ShipmentActions {
  /**
   * Takes a IShipmentActionsApiResponse from Packlink's API and returns a ShipmentActions.
   *
   * @param response  IShipmentActionsApiResponse response from Packlink's API.
   *
   */
  static createFromResponse(response) {
    return new ShipmentActions(response.CanBeCanceled, response.CanBeDeleted, response.CanBeModified, response.CanBePurchased, response.CanContactCustomerService, response.CanDownloadCustomsDocument, response.CanDownloadLabels, response.CanGetTrackingInfo, response.CanSelectAdultSignature, response.CanSelectInsurance, response.CanSelectPrintInStore, response.CanSelectProofOfDelivery, response.CanSelectService, response.CanUseSelectedService);
  }

  /**
   * Takes a serialized ShipmentActions and returns a ShipmentActions.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ShipmentActions.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedShipmentActions.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ShipmentActions.
   *
   */

  /**
   * Takes a serialized ShipmentActions and returns a ShipmentActions.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ShipmentActions.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedShipmentActions.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ShipmentActions.
   *
   */

  /**
   * Takes a serialized ShipmentActions and returns a ShipmentActions.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ShipmentActions.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedShipmentActions.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ShipmentActions.
   *
   */

  /**
   * Takes a serialized ShipmentActions and returns a ShipmentActions.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ShipmentActions.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedShipmentActions.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ShipmentActions.
   *
   */
  static deserialize(data) {
    if (!data) {
      return;
    }
    return new ShipmentActions(data.canBeCanceled, data.canBeDeleted, data.canBeModified, data.canBePurchased, data.canContactCustomerService, data.canDownloadCustomsDocument, data.canDownloadLabels, data.canGetTrackingInfo, data.canSelectAdultSignature, data.canSelectInsurance, data.canSelectPrintInStore, data.canSelectProofOfDelivery, data.canSelectService, data.canUseSelectedService);
  }

  /**
   * Returns a new ShipmentActions. Typings of the properties depend on the class type param T
   *
   */
  constructor(canBeCanceled, canBeDeleted, canBeModified, canBePurchased, canContactCustomerService, canDownloadCustomsDocument, canDownloadLabels, canGetTrackingInfo, canSelectAdultSignature, canSelectInsurance, canSelectPrintInStore, canSelectProofOfDelivery, canSelectService, canUseSelectedService) {
    this.canBeCanceled = canBeCanceled;
    this.canBeDeleted = canBeDeleted;
    this.canBeModified = canBeModified;
    this.canBePurchased = canBePurchased;
    this.canContactCustomerService = canContactCustomerService;
    this.canDownloadCustomsDocument = canDownloadCustomsDocument;
    this.canDownloadLabels = canDownloadLabels;
    this.canGetTrackingInfo = canGetTrackingInfo;
    this.canSelectAdultSignature = canSelectAdultSignature;
    this.canSelectInsurance = canSelectInsurance;
    this.canSelectPrintInStore = canSelectPrintInStore;
    this.canSelectProofOfDelivery = canSelectProofOfDelivery;
    this.canSelectService = canSelectService;
    this.canUseSelectedService = canUseSelectedService;
  }

  /**
   * Returns a JSON serialized version of the ShipmentActions.
   *
   */
  toJSON() {
    return {
      canBeCanceled: this.canBeCanceled,
      canBeDeleted: this.canBeDeleted,
      canBeModified: this.canBeModified,
      canBePurchased: this.canBePurchased,
      canContactCustomerService: this.canContactCustomerService,
      canDownloadCustomsDocument: this.canDownloadCustomsDocument,
      canDownloadLabels: this.canDownloadLabels,
      canGetTrackingInfo: this.canGetTrackingInfo,
      canSelectAdultSignature: this.canSelectAdultSignature,
      canSelectInsurance: this.canSelectInsurance,
      canSelectPrintInStore: this.canSelectPrintInStore,
      canSelectProofOfDelivery: this.canSelectProofOfDelivery,
      canSelectService: this.canSelectService,
      canUseSelectedService: this.canUseSelectedService
    };
  }

  /**
   * Returns a clone of the ShipmentActions.
   *
   */
  clone() {
    return new ShipmentActions(this.canBeCanceled, this.canBeDeleted, this.canBeModified, this.canBePurchased, this.canContactCustomerService, this.canDownloadCustomsDocument, this.canDownloadLabels, this.canGetTrackingInfo, this.canSelectAdultSignature, this.canSelectInsurance, this.canSelectPrintInStore, this.canSelectProofOfDelivery, this.canSelectService, this.canUseSelectedService);
  }

  /**
   * Returns whether the two ShipmentActions are equal.
   *
   */
  equals(shipmentActions) {
    if (!shipmentActions) {
      return false;
    }
    return this.canBeCanceled === shipmentActions.canBeCanceled && this.canBeDeleted === shipmentActions.canBeDeleted && this.canBeModified === shipmentActions.canBeModified && this.canBePurchased === shipmentActions.canBePurchased && this.canContactCustomerService === shipmentActions.canContactCustomerService && this.canDownloadCustomsDocument === shipmentActions.canDownloadCustomsDocument && this.canDownloadLabels === shipmentActions.canDownloadLabels && this.canGetTrackingInfo === shipmentActions.canGetTrackingInfo && this.canSelectAdultSignature === shipmentActions.canSelectAdultSignature && this.canSelectInsurance === shipmentActions.canSelectInsurance && this.canSelectPrintInStore === shipmentActions.canSelectPrintInStore && this.canSelectProofOfDelivery === shipmentActions.canSelectProofOfDelivery && this.canSelectService === shipmentActions.canSelectService && this.canUseSelectedService === shipmentActions.canUseSelectedService;
  }
}) || _class);

export { ShipmentActions };
//# sourceMappingURL=ShipmentActions.js.map
